import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { loadConfig } from './config';

// Patch ResizeObserver to prevent harmless errors
// This is needed for Radix UI Select components
if (typeof window !== 'undefined') {
  const OriginalResizeObserver = window.ResizeObserver;

  window.ResizeObserver = class extends OriginalResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  };
}

// Load runtime config, then dynamically import App so that module-scope
// code in App.js can read config values at startup.
loadConfig().then(async () => {
  // Initialize PostHog after config is loaded so it uses runtime keys
  const { initializePostHog } = await import('./utils/analytics');
  initializePostHog();

  const { default: App } = await import('./App');

  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}).catch((error) => {
  // If bootstrap itself fails (config fetch, App chunk after a deploy), show
  // a static retry message instead of a permanently blank page.
  console.error('[bootstrap] failed to load app:', error);
  const rootEl = document.getElementById('root');
  if (rootEl) {
    rootEl.innerHTML = `
      <div style="min-height:100vh;display:flex;align-items:center;justify-content:center;background-color:#FBF6EE;font-family:system-ui,sans-serif;padding:1rem;">
        <div style="background:#fff;border-radius:8px;box-shadow:0 4px 12px rgba(26,26,26,0.15);padding:2rem;max-width:28rem;text-align:center;">
          <h2 style="color:#1A1A1A;margin:0 0 0.5rem;">GOE couldn't load</h2>
          <p style="color:#666;margin:0 0 1.5rem;font-size:0.875rem;">Check your connection, then reload the page.</p>
          <button onclick="window.location.reload()" style="background:#004E89;color:#fff;border:none;border-radius:6px;padding:0.6rem 1.25rem;font-size:0.9rem;cursor:pointer;">Reload page</button>
        </div>
      </div>`;
  }
});
